<template>
    <div class="panel panel-offset">
        <div class="panel-heading qaqc-bg">
            <h3 class="panel-title">QA/QC Progress</h3>
        </div>
        <div class="panel-body">
            <div class="container" v-if="!isSegment">
                <h4>Recording</h4>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Overview</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.identification)">
                        {{completedLabel(qaqcProgressDto.identification)}}
                    </div>
                    <div class="col-sm-1"></div>
                    <label class="col-sm-2 control-label text-label">Location</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.location)">
                        {{completedLabel(qaqcProgressDto.location)}}
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Register Status</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.nationalRegisterStatus)">
                        {{completedLabel(qaqcProgressDto.nationalRegisterStatus)}}
                    </div>
                    <div class="col-sm-1"></div>
                    <label class="col-sm-2 control-label text-label">Investigative History</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.investigativeHistory)">
                        {{completedLabel(qaqcProgressDto.investigativeHistory)}}
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Property Description</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.propertyDescription)">
                        {{completedLabel(qaqcProgressDto.propertyDescription)}}
                    </div>
                    <div class="col-sm-1"></div>
                    <label class="col-sm-2 control-label text-label">Site Setting</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.siteSetting)">
                        {{completedLabel(qaqcProgressDto.siteSetting)}}
                    </div>
                </div>
            </div>
            <div class="container" v-if="isSegment">
                <h4>Recording</h4>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Overview</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.identification)">
                        {{completedLabel(qaqcProgressDto.identification)}}
                    </div>
                </div>
            </div>
            <div class="container">
                <hr />
                <h4>Site (Condition) Narrative / Property Description & History</h4>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Site (Condition) Narrative / Property Description & History</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.siteNarrativeBuildingDescHistory)">
                        {{completedLabel(qaqcProgressDto.siteNarrativeBuildingDescHistory)}}
                    </div>
                </div>
            </div>
            <div class="container">
                <hr />
                <h4>Shape File Append</h4>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Shape File Append</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.shapeFileAppend)">
                        {{completedLabel(qaqcProgressDto.shapeFileAppend)}}
                    </div>
                </div>
            </div>
            <div class="container">
                <hr />
                <h4>Attachments</h4>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Prehistoric Artifacts</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.prehistoricArtifact)">
                        {{completedLabel(qaqcProgressDto.prehistoricArtifact)}}
                    </div>
                    <div class="col-sm-1"></div>
                    <label class="col-sm-2 control-label text-label">Prehistoric Features</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.prehistoricFeature)">
                        {{completedLabel(qaqcProgressDto.prehistoricFeature)}}
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Historic Artifacts</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.historicArtifact)">
                        {{completedLabel(qaqcProgressDto.historicArtifact)}}
                    </div>
                    <div class="col-sm-1"></div>
                    <label class="col-sm-2 control-label text-label">Historic Features</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.historicFeature)">
                        {{completedLabel(qaqcProgressDto.historicFeature)}}
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Rock Art</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.rockArt)">
                        {{completedLabel(qaqcProgressDto.rockArt)}}
                    </div>
                    <div class="col-sm-1"></div>
                    <label class="col-sm-2 control-label text-label">Historic Building</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.historicBuilding)">
                        {{completedLabel(qaqcProgressDto.historicBuilding)}}
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Linear Resource</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.linearResource)">
                        {{completedLabel(qaqcProgressDto.linearResource)}}
                    </div>
                    <div class="col-sm-1"></div>
                    <label class="col-sm-2 control-label text-label">Structure Object</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.structureObject)">
                        {{completedLabel(qaqcProgressDto.structureObject)}}
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label text-label">Unknown Features</label>
                    <div class="col-sm-3 text-label alert" v-bind:class="alertClass(qaqcProgressDto.unknownFeature)">
                        {{completedLabel(qaqcProgressDto.unknownFeature)}}
                    </div>
                </div>
            </div>
            <div v-if="isDebug">
                {{qaqcProgressDto}}
            </div>
        </div>
    </div>
</template>

<script>

import loggingService from '@/services/util/loggingService'

export default {
    name: 'qaqcProgress',
    props: {
        qaqcProgressDto: {},
        isSegment: { default: false }
    },
    data: function () {
        return {
            isDebug: false
        }
    },
    mounted () {
        this.log('Mounted')
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'QA/QC Progress', message)
        },
        completedLabel (bool) {
            return bool ? 'Completed' : 'Not Completed'
        },
        alertClass (bool) {
            return bool ? 'alert-success' : 'alert-danger'
        }
    }
}
</script>

<style lang="css">
.divider {
    margin-top: 20px;
}

.alert {
    margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// QaqcProgress.vue?34e4c8c4